/* eslint-disable no-else-return */
import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'
import { claimActions, geoActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import ClaimCoupon from './ClaimCoupon/ClaimCoupon'
import Select from './Select/Select'
import Confirm from './Confirm/Confirm'
import Summary from './Summary/Summary'
import Survey from './Survey/Survey'
import claimSteps from '../../../shared/claimSteps.json'
import Failed from './Failed/Failed'
import { currentUser } from '../../redux/reducers/user.reducers'
import Error from '../../components/Error/Error'

class ClaimReward extends React.Component {
  componentDidMount() {
    const { getCountry } = this.props
    getCountry()
  }

  componentWillUnmount() {
    const { clearRedeemState, claimError } = this.props
    if (!claimError) clearRedeemState()
  }

  _renderSubComponent = () => {
    const { claimStep } = this.props

    if (claimStep === claimSteps.CLAIM_COUPON) {
      return <ClaimCoupon />
    } else if (claimStep === claimSteps.ATTEMPT_SURVEY) {
      return <Survey />
    } else if (claimStep === claimSteps.SELECT_REWARD) {
      return <Select />
    } else if (claimStep === claimSteps.CONFIRM_REWARD) {
      return <Confirm />
    } else if (claimStep === claimSteps.REWARD_SUMMARY) {
      return <Summary />
    } else if (claimStep === claimSteps.ERROR) {
      return <Failed />
    }
  }

  render() {
    const { intl, securityBlockedError, securityBlockedMessage } = this.props
    const label = intl.formatMessage({ id: 'global.pageTitles.claimReward' })

    if (securityBlockedError) {
      return (
        <Error message={securityBlockedMessage} dontShowSupport header="global.label.attention" />
      )
    }

    return (
      <div className="container mt-5 mb-5" aria-labelledby="claim-reward-hero-title">
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <h1 className="page-title" id="claim-reward-hero-title">
          <FormattedMessage id="page.redemptionPage.title.heroTitle" />
        </h1>
        {this._renderSubComponent()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: currentUser(state),
  claimStep: state.claimReducers.claimStep,
  claimError: state.claimReducers.error,
  securityBlockedError: state.userReducers.securityBlockedError,
  securityBlockedMessage: state.userReducers.securityBlockedMessage,
})

const mapDispatchToProps = dispatch => ({
  getCountry: () => dispatch(geoActions.getCountry()),
  clearRedeemState: (...args) => dispatch(claimActions.clearRedeemState(...args)),
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ClaimReward))
